import { createTheme } from '@mui/material/styles';
import colors from './colors';

const theme = createTheme();
const primary = 'Din, Helvetica, sans-serif';
const secondary = 'Zizzi, Helvetica, sans-serif';

const typography = {
  typography: {
    fontFamily: primary,

    h1: {
      fontFamily: secondary,
      fontSize: '32px',
      marginBottom: '1rem',
      fontWeight: 800,

      [theme.breakpoints.up('sm')]: {
        fontSize: '64px',
      },
    },

    h2: {
      fontFamily: secondary,
      fontSize: '24px',
      fontWeight: 800,
      marginBottom: '10px',

      [theme.breakpoints.up('sm')]: {
        fontSize: '40px',
      },
    },

    h3: {
      fontFamily: secondary,
      fontSize: '16px',

      [theme.breakpoints.up('sm')]: {
        fontSize: '18px',
      },
    },

    h4: {
      fontFamily: primary,
      fontSize: '20px',
      fontWeight: 'bold',

      [theme.breakpoints.up('sm')]: {
        fontSize: '32px',
      },
    },

    h5: {
      fontFamily: primary,
      fontSize: '18px',
      fontWeight: 800,

      [theme.breakpoints.up('sm')]: {
        fontSize: '20px',
      },
    },

    h6: {
      fontFamily: primary,
      fontSize: '14px',

      [theme.breakpoints.up('sm')]: {
        fontSize: '16px',
      },
    },

    body1: {
      lineHeight: 1.4,
      fontSize: '16px',

      [theme.breakpoints.up('sm')]: {
        fontSize: '18px',
      },

      a: {
        color: colors.palette.primary.main,
      },
    },

    body2: {
      lineHeight: 1.4,
      fontSize: '14px',
    },

    subtitle1: {
      fontSize: '16px',
    },

    subtitle2: {
      fontFamily: secondary,
      fontSize: '20px',
      fontWeight: 800,
    },

    caption: {
      fontSize: '12px',
    },
  },
};

export default typography;
